var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHhmiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 40,
    viewBox: "0 0 133 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.448944H10.9151V14.1258H11.0255C12.8996 11.9463 15.3253 10.3662 19.9563 10.3662C25.0832 10.3662 29.7689 13.472 29.7689 19.9562V39.355H18.8536V24.5331C18.8536 21.2643 18.4677 18.9751 15.2705 18.9751C13.396 18.9751 10.9151 19.9019 10.9151 24.4242V39.355H0V0.448944Z",
    fill: "#97A2B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5479 0.448944H45.4629V14.1258H45.5736C47.4479 11.9463 49.8734 10.3662 54.5044 10.3662C59.6311 10.3662 64.3172 13.472 64.3172 19.9562V39.355H53.4018V24.5331C53.4018 21.2643 53.0158 18.9751 49.8185 18.9751C47.9441 18.9751 45.4629 19.9019 45.4629 24.4242V39.355H34.5479V0.448944Z",
    fill: "#97A2B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.064 11.0747H79.5944V14.8345H79.7042C81.9094 11.5643 85.107 10.3662 89.0763 10.3662C92.1635 10.3662 95.4709 11.9463 96.794 14.7795C97.235 14.4526 99.4401 10.3662 106.552 10.3662C113.884 10.3662 116.365 15.3792 116.365 19.9562V39.355H105.449V24.0434C105.449 21.373 105.174 18.9751 101.865 18.9751C99.1095 18.9751 98.1719 21.1006 98.1719 24.0434V39.355H87.2572V24.0434C87.2572 21.373 86.9809 18.9751 83.6735 18.9751C80.9169 18.9751 79.9799 21.1006 79.9799 24.0434V39.355H69.064V11.0747Z",
    fill: "#97A2B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.011 39.355H131.927V11.0746H121.011V39.355Z",
    fill: "#97A2B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.214 7.60986C132.376 7.07609 132.464 6.51045 132.464 5.9241C132.464 2.65243 129.781 -0.000213146 126.471 -0.000213146C123.161 -0.000213146 120.477 2.65243 120.477 5.9241C120.477 6.51045 120.566 7.07609 120.727 7.60986H132.214Z",
    fill: "#97A2B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHhmiLogo);
export default __webpack_public_path__ + "static/media/hhmi-logo.69ac0280143e9b94ab7930ba56dcb15b.svg";
export { ForwardRef as ReactComponent };